import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Row, Col } from "react-bootstrap";
import { array, object } from "prop-types";

const GAME = ({
  candidateInfo,
  scoreRangeOptions,
  SubcategoryScoreColumns,
  SelectedScoreRangeSection,
  testScores,
}) => {
  // ---------------------------- Results Details ----------------------------
  const getResultDetails = () => {
    const percentile = testScores && testScores.get("percentile");
    const firstName = candidateInfo && candidateInfo.get("testTakerFirstName");
    const lastName = candidateInfo && candidateInfo.get("testTakerLastName");
    return (
      <Row className="ml-1">
        <h3 className="reportHeader mt-4">Results Details</h3>
        <p>
          {firstName} {lastName} achieved an overall score of {percentile}{" "}
          percentile, meaning that {firstName} scored better than {percentile}%
          of the people who have taken this assessment. Below are details of how{" "}
          {firstName} performed on each specific area within the test.
        </p>
        {SubcategoryScoreColumns}
      </Row>
    );
  };

  // ---------------------------- Suggested GAME Percentile Ranges by Position ----------------------------
  const getTableSection = () => {
    if (!scoreRangeOptions) {
      return null;
    }

    const data = [];
    scoreRangeOptions.forEach((rangeObj, rangeName) => {
      const [bottom, top] = rangeObj.get("range").split(",");
      data.push({
        rangeName,
        range: `${bottom} - ${top}`,
        inRange: isInRange(Number(bottom), Number(top)),
      });
    });

    return (
      <Row>
        <Col>
          <h3 className="reportHeader my-2">
            Suggested GAME Percentile Ranges by Position
          </h3>
          <BootstrapTable
            keyField="rangeName"
            data={data}
            columns={[
              {
                dataField: "rangeName",
                text: "Position",
                classes: "font-weight-bold",
              },
              {
                dataField: "range",
                text: "Score Range",
              },
              {
                dataField: "inRange",
                text: "In Range?",
              },
            ]}
            striped
          />
        </Col>
      </Row>
    );
  };

  const isInRange = (bottom, top) => {
    const percentile = testScores && Number(testScores.get("percentile"));
    if (percentile < bottom) {
      return "Below Range";
    }
    if (percentile > top) {
      return "Above Range";
    }
    return "In Range";
  };

  return (
    <Col>
      {getResultDetails()}
      <hr className="divider" />
      {SelectedScoreRangeSection}
      {SelectedScoreRangeSection && <hr className="divider" />}
      {getTableSection()}
    </Col>
  );
};

GAME.propTypes = {
  candidateInfo: object,
  scoreRangeOptions: object,
  SubcategoryScoreColumns: array,
  SelectedScoreRangeSection: object,
  testScores: object,
};

export default GAME;
